<template>
  <DotLottieVue ref="Service4" class="size-[200px] lg:size-[15vw]" autoplay :src="props.src" />
</template>

<script setup>
const props = defineProps({
  src: {
    type: String,
    default: "",
  },
})

const Service4 = ref();

const initiateInterval = () => {
  setInterval(() => {
    if (Service4.value && import.meta.client) {
      const lottieInstance = Service4.value.getDotLottieInstance()
      lottieInstance.play()
    }
  }, 9400)
}

onMounted(() => {
  nextTick(() => {
    initiateInterval()
  })
})
</script>
